import { css } from '@emotion/react';

export const widgetLabelStyles = css`
    position: absolute;
    height: 42px;
    bottom: 61px;
    z-index: 1;
    white-space: nowrap;
    font-size: 17px;
    line-height: 17px;
    //Don't use RTL here
    .widget-position-left & {
        /*! @noflip */
        left: 100px;
    }
    .widget-position-right & {
        /*! @noflip */
        right: 100px;
    }

    border-radius: var(--radius-component, 16px);
    padding-block: var(--label-padding-block, 10px);
    padding-inline: var(--label-padding-inline, 15px);
    box-shadow: var(--label-shadow);
    background: #fff;
`;

export const dynamicTextLabelStyles = css`
    height: auto;
    min-height: 42px;
    max-width: 280px;
    width: auto;
    white-space: normal;
    text-align: left;
    line-height: 20px;

    span {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-word;
        overflow-wrap: break-word;
    }
`;
